import { ActionTypes } from "redux/actions/actionType";
import {
    Announcement,
    AnnouncementForm,
    AnnouncementsTemplates,
    AnnouncementTemplateForm,
} from "types/types";

export const setAnnouncement = ( announcement: Announcement ) => {
    return {
        type: ActionTypes.SET_ANNOUNCEMENT,
        payload: announcement
    }
};

export const setAnnouncementForm = ( updatedAnnouncementForm: AnnouncementForm ) => {
    return {
        type: ActionTypes.SET_ANNOUNCEMENT_FORM,
        payload: updatedAnnouncementForm,
    };
};

export const setAnnouncementsTemplates = ( announcementsTemplates: AnnouncementsTemplates ) => {
    return {
        type: ActionTypes.SET_ANNOUNCEMENTS_TEMPLATES,
        payload: announcementsTemplates
    }
};
export const setAnnouncementTemplateForm = ( announcementTemplateForm: AnnouncementTemplateForm ) => {
    return {
        type: ActionTypes.SET_ANNOUNCEMENT_TEMPLATE_FORM,
        payload: announcementTemplateForm
    }
};
